const getPlannerCardsEndpoint = (goalUID) =>
  `v2/planner/cards/?goal_uid=${goalUID}&type=v2`;

export default getPlannerCardsEndpoint;
